import React, { FunctionComponent } from 'react'
import { getConfigValue } from 'src/utils/config/config'
import { FeatureFlag } from '../components/feature_flag/feature_flag'
import { TWO_COLUMNS } from '../constants/layout'

import LayoutMap, { LayoutMapContainerProps } from './layout_map_container'
import LayoutNoMap, { LayoutNoMapProps } from './layout_no_map'

type IProps = LayoutMapContainerProps & LayoutNoMapProps;

export const LayoutFeaturedContainer: FunctionComponent<IProps> = ({ children, ...props }) => {
  const isMapEnabled = getConfigValue<boolean>('featureFlags.map.enabled')

  return <FeatureFlag active={isMapEnabled} fallback={
    <LayoutNoMap {...props} contentWidth={TWO_COLUMNS}>
      {children}
    </LayoutNoMap>
  }>
    <LayoutMap {...props}>
      {children}
    </LayoutMap>
  </FeatureFlag>
}
